import { render, staticRenderFns } from "./Mongo.vue?vue&type=template&id=396f4c34"
import script from "./Mongo.vue?vue&type=script&lang=js"
export * from "./Mongo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports